<div [attr.id]="id"
     [attr.aria-label]="ariaLabel ? ariaLabel : label"
     [ngStyle]="style"
     [class]="class">
    <h5 *ngIf="label"> {{ label }} </h5>
    <ng-content> </ng-content>
</div>